import React from "react";
import { Route, Routes } from "react-router-dom";
import { AccountTopNav } from "./AccountNav";
import PlanNav from "./PlanNav";
import { ShowTopNav } from "./ShowNav";
import "./top-nav.scss";

export default function TopNav() {
    return (
        <Routes>
            <Route path="profile" element={<Empty />} />
            <Route path=":accountID/*" element={<Nav />} />
        </Routes>
    );
}
export function Nav() {
    return (
        <div className="top-nav">
            <Routes path=":accountID/*">
                <Route path="*" element={<AccountTopNav />} />
                <Route path="shows/:showID/*" element={<ShowTopNav />} />
            </Routes>
            <Routes path=":accountID/*">
                <Route path="upgrade" element={<Empty />} />
                <Route path="*" element={<PlanNav />} />
            </Routes>
        </div>
    );
}

const Empty = () => null;
